import { Outlet, useLocation } from 'react-router-dom';
import NavBar from './navbar';
// import TabComponent from './tabComponent';

const WorkspaceComp = () => {
    
    // const location = useLocation();
    // const hideNavBar = location.pathname === '/';

    return (
        <>
        {/* {!hideNavBar && <TabComponent/>} */}
            <NavBar />
            <Outlet />
        </>
    );
}

export default WorkspaceComp